/*
 * @Description 组件 Index 布局
 * @Author 
 * @Date 
 */
/* HTML */
<template>
	<section style="height: 100%;width: 100%;">
		<!-- view-index-page start -->
		<div class="view-index-page">
			<!--app-index-box start -->
			<div class="app-index-box">
				<!-- app-index-view start -->
				<div class="app-index-view">
					
					<!-- 组件 IndexLeft -->
					<IndexLeft />
					<!-- 组件 IndexCenter -->
					<IndexCenter />
					<!-- 组件 IndexRight -->
					<IndexRight />
					
				</div>
				<!-- app-index-view end -->
			</div>
			<!--app-index-box end -->
		</div>
		<!-- view-index-page end -->
	</section>
</template>

/* JS */
<script>
	// 组件 IndexLeft
	import IndexLeft from '@/components_index/IndexPage/IndexLeft';
	// 组件 IndexCenter
	import IndexCenter from '@/components_index/IndexPage/IndexCenter';
	// 组件 IndexRight
	import IndexRight from '@/components_index/IndexPage/IndexRight';
	
	export default {
		/**
		 * @Des 组件名
		 * @Auth
		 * @Date 
		 */
        name: "Index",
        
        /**
		 * @Des 组件注册
		 * @Auth
		 * @Date 
		 */
        components: {
        	// 组件 IndexLeft
        	IndexLeft,
        	// 组件 IndexCenter
        	IndexCenter,
        	// 组件 IndexRight
        	IndexRight,
        },// components
        
        /**
		 * @Des 属性值
		 * @Auth
		 * @Date 
		 */
        props: {
        	
        },// props
        
        /**
		 * @Des 数据定义
		 * @Auth
		 * @Date 
		 */
		data() {
			return {
				
			}
		},// data
		
		/**
		 * @Des 初始化
		 * @Auth
		 * @Date 
		 */
		created() {
			
		},// created
		
		/**
		 * @Des 加载完成
		 * @Auth
		 * @Date 
		 */
		mounted() {
			// body class
			document.getElementsByTagName('body')[0].className = 'home-page-view';
		},// mounted
		
		/**
		 * @Des 销毁之前
		 * @Auth
		 * @Date 
		 */
		beforeDestroy() {
			// body class
			document.getElementsByTagName('body')[0].className = '';
		},// beforeDestroy
		
		/**
		 * @Des 销毁
		 * @Auth
		 * @Date 
		 */
		destroyed() {
			
		},// destroyed
		
		/**
		 * @Des 方法定义
		 * @Auth
		 * @Date 
		 */
		methods: {
			
		},// methods
		
		/**
		 * @Des 监听
		 * @Auth
		 * @Date 
		 */
		watch: {
			
		},// watch
		
		/**
		 * @Des 实时计算
		 * @Auth
		 * @Date 
		 */
		computed: {
			
		},// computed
		
    }// export default
</script>

/* CSS */
<style src="@/static_dazzle/css/index/index.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
	
</style>



// WEBPACK FOOTER //
// src/views/system-tunnel/Index.vue